import {
  default as MuiToolbar,
  type ToolbarProps as MuiToolbarProps,
  toolbarClasses as muiToolbarClasses,
} from '@mui/material/Toolbar';

/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const Toolbar = MuiToolbar;
/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export type ToolbarProps = MuiToolbarProps;
/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const toolbarClasses = muiToolbarClasses;
